import { createApiSlice } from "@common";
import { CRUD_OPPORTUNITY_TYPE } from "@routes";

// Define the API config array
const apiConfig = [
  {
    name: "addOpportunityType",
    method: "post",
    url: CRUD_OPPORTUNITY_TYPE,
    stateKey: "message",
  },
  {
    name: "getOpportunityType",
    method: "get",
    url: CRUD_OPPORTUNITY_TYPE,
    stateKey: "data",
  },
  {
    name: "updateOpportunityType",
    method: "put",
    url: CRUD_OPPORTUNITY_TYPE,
    stateKey: "message",
  },
  {
    name: "deleteOpportunityType",
    method: "delete",
    url: CRUD_OPPORTUNITY_TYPE,
    stateKey: "message",
  },
];

// Define custom reducers and their initial state
const customReducers = {
  initialState: {
    data: [],
    additionalData: [],
  },
  reducers: {
    setAdditionalData: (state, action) => {
      state.additionalData = action.payload;
    },
  },
  extraReducers: {},
};

// Generate the slice, thunks, and actions using the utility function
const { slice, thunks, actions } = createApiSlice(
  "opportunityType",
  apiConfig,
  customReducers,
);
const opportunityTypeSlice = slice;

// Export the slice's reducer
export default opportunityTypeSlice.reducer;

// Export thunks
export const {
  addOpportunityType,
  getOpportunityType,
  updateOpportunityType,
  deleteOpportunityType,
} = thunks;

// Export actions
export const { rowSelect } = actions;
